import SurveysRepository from "./repositories/surveysRepository";
import AdManagerRepository from "./repositories/adManagerRepository";
import LayoutRepository from "./repositories/layoutsRepository";
import SiteRepository from "./repositories/sitesRepository";

const repositories = {
    surveys: SurveysRepository,
    adManager: AdManagerRepository,
    layouts: LayoutRepository,
    sites: SiteRepository
};

export const RepositoryFactory = {
    get: name => repositories[name]
};